<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
const $q = useQuasar()
const settings = useUserSettings()
const { setLocale, t } = useI18n()
setLocale(settings.lang)
useSeoMeta({
  title: t('seo.title'),
  ogTitle: t('seo.title'),
  description: t('seo.description'),
  ogDescription: t('seo.description')
})
// Quasar Notify plugin defaults
$q.notify.setDefaults({
  position: 'top',
  timeout: 5000,
  type: 'positive',
  actions: [{ icon: 'mdi-close', color: 'white' }]
})
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.3s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(0.5rem);
}
</style>